import { updateEmergencyLog } from "../../services/userApiServicer";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Sidemenu from '../base/sidemenu';
import moment from "moment"

export default function UserAlertEdit() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { log, adminId } = state || {};
  const [content, setContent] = useState(log?.content || "");
 const token = localStorage.getItem("token");
 const handleUpdate = async () => {
  try {
    console.log("수정 요청 전송", {
      alert_id: log.alert_id,
      content,
      admin_id: adminId,
      token,
    });

    const data = await updateEmergencyLog({
      alert_id: log.alert_id,
      content,
      admin_id: adminId,
      token, // ✅ 토큰 전달
    });

    if (data.success === false) {
      alert(data.message);
      return;
    }

    alert("수정이 완료되었습니다.");
    navigate(-1);
  } catch (error) {
    alert("수정 실패");
  }
};

  return (
    <div className='flex'>
          <Sidemenu />
          <div className="user">
            <h1>응급상황 기록 수정</h1>
            <div className="user_box">
                <div className="user_alert_edit">
                <h2 className="subpage_title">{moment(log?.create_date).format("YYYY-MM-DD")} 발생한 응급상황 수정</h2>
                    <div className="formbox">
                        <label>증상 및 상황조치</label>
                        <textarea value={content} onChange={(e) => setContent(e.target.value)} rows={10} style={{ width: "100%", resize: "vertical" }}/>
                    </div>
                    <div className="btn-group">
                        <button className="btncolor04" onClick={handleUpdate}>저장</button>
                        <button className="btncolor01" onClick={() => navigate(-1)}>취소</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}
